// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fileExplorerContainer {
    .collectionButtons {
        margin-left: 5px;
    }

    .create-folder-btn {
        background-color: #3498db;
        color: white;
        border: none;
        cursor: pointer;
        transition: background-color 0.3s ease;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    .create-folder-btn:hover {
        background-color: #2980b9;
        /* Darker blue on hover */
    }

    .create-folder-btn:active {
        background-color: #1c5d8a;
        /* Even darker blue when clicked */
        color: white;
    }

    .create-folder-btn:focus {
        outline: none;
        /* Remove default focus outline */
    }


    .delete-folder-btn {
        background-color: #e74c3c;
        color: white;
        border: none;
        cursor: pointer;
        transition: background-color 0.3s ease;
        /* Smooth background color transition */
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        /* Soft shadow for depth */
    }

    .delete-folder-btn:hover {
        background-color: #c0392b;
        /* Darker blue on hover */
    }

    .delete-folder-btn:active {
        background-color: #c0392b;
        /* Even darker blue when clicked */
        color: white;
    }

    .delete-folder-btn:focus {
        outline: none;
        /* Remove default focus outline */
    }

    .upload-btn {
        background-color: #3498db;
        color: white;
        border: none;
        cursor: pointer;
        transition: background-color 0.3s ease;
        /* Smooth background color transition */
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    .upload-btn:hover {
        background-color: #2980b9;
        /* Darker blue on hover */
    }

    .upload-btn:active {
        background-color: #2980b9;
        /* Even darker blue when clicked */
        color: white;
    }

    .upload-btn:focus {
        outline: none;
        /* Remove default focus outline */
    }

    .upload-btn-icon {
        background-color: #8551da;
        color: white;
        border: none;
        cursor: pointer;
        transition: background-color 0.3s ease;
        /* Smooth background color transition */
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    .upload-btn-icon:hover {
        background-color: #8429b9;
        /* Darker blue on hover */
    }

    .upload-btn-icon:active {
        background-color: #8429b9;
        /* Even darker blue when clicked */
        color: white;
    }

    .upload-btn-icon:focus {
        outline: none;
        /* Remove default focus outline */
    }

    .fileViewAlertcontainer {
        margin-top: 0.5%;
        position: absolute;

        .alertImg {
            margin-left: 3%;
        }

        #toast {
            visibility: hidden;
            border: 1px solid;
            border-left: 10px solid;
            height: auto;
            width: -moz-fit-content !important;
            width: fit-content !important;
            background-color: #ffffff;
            color: #000000;
            text-align: center;
            border-radius: 2px;
            position: fixed;
            z-index: 1301;
            left: 0;
            right: 0;
            bottom: 36px;
            font-size: 17px;
            margin-right: 26px;
            place-self: end;
        }

        .toastCloser {
            margin-top: -6%;
            background: transparent;
            border: none;
        }

        #toast.show {
            visibility: visible;
            animation: fadein 0.5s, fadeout 0.5s 1.5s;
        }

        @keyframes fadein {
            from {
                left: 30%;
                opacity: 0;
            }

            to {
                left: 0%;
                opacity: 1;
            }
        }

        @keyframes fadeout {
            from {
                left: 0%;
                opacity: 1;
            }

            to {
                left: 30%;
                opacity: 0;
            }
        }

        .messageheadContainer {
            display: flex;
            width: 100%;
            justify-content: space-between;
            padding: 0%;
            padding-top: 1%;
            padding-left: 5%;
            padding-bottom: 0%;
        }

        .toast-check {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 35px;
            width: 35px;
            background-color: #40f467;
            border-radius: 50%;
            color: #fff;
            font-size: 20px;
        }

        .message {
            display: flex;
            flex-direction: column;
            margin: 1px 20px 0px 7px;
            text-align: left;
            padding-left: 3%;
        }

        .message-text {
            font-size: 20px;
            font-weight: 600;
        }

        .text-1 {
            color: #333;
            margin-top: 1%;
        }

        .text-2 {
            color: #666;
            font-weight: 400;
            font-size: 16px;
            min-width: 202px;
            height: auto;
        }

        .toast-close {
            position: absolute;
            top: 10px;
            right: 15px;
            padding: 5px;
            cursor: pointer;
            opacity: 0.7;
        }

        .toast-close:hover {
            opacity: 1;
        }
    }

    .initialLoader {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        /* Semi-transparent background */
        justify-content: center;
        align-items: center;
        z-index: 9999;
        /* Ensure it's above all other elements */
        display: flex;
        flex-direction: column;
    }

    .fileUploadText {
        color: white;
        font-size: 25px;
        font-weight: 600;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/file_explorer_view.css"],"names":[],"mappings":"AAAA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,sCAAsC;QACtC,wCAAwC;IAC5C;;IAEA;QACI,yBAAyB;QACzB,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,kCAAkC;QAClC,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,iCAAiC;IACrC;;;IAGA;QACI,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,sCAAsC;QACtC,uCAAuC;QACvC,wCAAwC;QACxC,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;QACzB,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,kCAAkC;QAClC,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,iCAAiC;IACrC;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,sCAAsC;QACtC,uCAAuC;QACvC,wCAAwC;IAC5C;;IAEA;QACI,yBAAyB;QACzB,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,kCAAkC;QAClC,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,iCAAiC;IACrC;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,YAAY;QACZ,eAAe;QACf,sCAAsC;QACtC,uCAAuC;QACvC,wCAAwC;IAC5C;;IAEA;QACI,yBAAyB;QACzB,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,kCAAkC;QAClC,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,iCAAiC;IACrC;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;;QAElB;YACI,eAAe;QACnB;;QAEA;YACI,kBAAkB;YAClB,iBAAiB;YACjB,uBAAuB;YACvB,YAAY;YACZ,kCAA6B;YAA7B,6BAA6B;YAC7B,yBAAyB;YACzB,cAAc;YACd,kBAAkB;YAClB,kBAAkB;YAClB,eAAe;YACf,aAAa;YACb,OAAO;YACP,QAAQ;YACR,YAAY;YACZ,eAAe;YACf,kBAAkB;YAClB,eAAe;QACnB;;QAEA;YACI,eAAe;YACf,uBAAuB;YACvB,YAAY;QAChB;;QAEA;YACI,mBAAmB;YAEnB,yCAAyC;QAC7C;;QAcA;YACI;gBACI,SAAS;gBACT,UAAU;YACd;;YAEA;gBACI,QAAQ;gBACR,UAAU;YACd;QACJ;;QAcA;YACI;gBACI,QAAQ;gBACR,UAAU;YACd;;YAEA;gBACI,SAAS;gBACT,UAAU;YACd;QACJ;;QAEA;YACI,aAAa;YACb,WAAW;YACX,8BAA8B;YAC9B,WAAW;YACX,eAAe;YACf,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,YAAY;YACZ,WAAW;YACX,yBAAyB;YACzB,kBAAkB;YAClB,WAAW;YACX,eAAe;QACnB;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,wBAAwB;YACxB,gBAAgB;YAChB,gBAAgB;QACpB;;QAEA;YACI,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,WAAW;YACX,cAAc;QAClB;;QAEA;YACI,WAAW;YACX,gBAAgB;YAChB,eAAe;YACf,gBAAgB;YAChB,YAAY;QAChB;;QAEA;YACI,kBAAkB;YAClB,SAAS;YACT,WAAW;YACX,YAAY;YACZ,eAAe;YACf,YAAY;QAChB;;QAEA;YACI,UAAU;QACd;IACJ;;IAEA;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,oCAAoC;QACpC,gCAAgC;QAChC,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;QACb,yCAAyC;QACzC,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".fileExplorerContainer {\n    .collectionButtons {\n        margin-left: 5px;\n    }\n\n    .create-folder-btn {\n        background-color: #3498db;\n        color: white;\n        border: none;\n        cursor: pointer;\n        transition: background-color 0.3s ease;\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    }\n\n    .create-folder-btn:hover {\n        background-color: #2980b9;\n        /* Darker blue on hover */\n    }\n\n    .create-folder-btn:active {\n        background-color: #1c5d8a;\n        /* Even darker blue when clicked */\n        color: white;\n    }\n\n    .create-folder-btn:focus {\n        outline: none;\n        /* Remove default focus outline */\n    }\n\n\n    .delete-folder-btn {\n        background-color: #e74c3c;\n        color: white;\n        border: none;\n        cursor: pointer;\n        transition: background-color 0.3s ease;\n        /* Smooth background color transition */\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n        /* Soft shadow for depth */\n    }\n\n    .delete-folder-btn:hover {\n        background-color: #c0392b;\n        /* Darker blue on hover */\n    }\n\n    .delete-folder-btn:active {\n        background-color: #c0392b;\n        /* Even darker blue when clicked */\n        color: white;\n    }\n\n    .delete-folder-btn:focus {\n        outline: none;\n        /* Remove default focus outline */\n    }\n\n    .upload-btn {\n        background-color: #3498db;\n        color: white;\n        border: none;\n        cursor: pointer;\n        transition: background-color 0.3s ease;\n        /* Smooth background color transition */\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    }\n\n    .upload-btn:hover {\n        background-color: #2980b9;\n        /* Darker blue on hover */\n    }\n\n    .upload-btn:active {\n        background-color: #2980b9;\n        /* Even darker blue when clicked */\n        color: white;\n    }\n\n    .upload-btn:focus {\n        outline: none;\n        /* Remove default focus outline */\n    }\n\n    .upload-btn-icon {\n        background-color: #8551da;\n        color: white;\n        border: none;\n        cursor: pointer;\n        transition: background-color 0.3s ease;\n        /* Smooth background color transition */\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    }\n\n    .upload-btn-icon:hover {\n        background-color: #8429b9;\n        /* Darker blue on hover */\n    }\n\n    .upload-btn-icon:active {\n        background-color: #8429b9;\n        /* Even darker blue when clicked */\n        color: white;\n    }\n\n    .upload-btn-icon:focus {\n        outline: none;\n        /* Remove default focus outline */\n    }\n\n    .fileViewAlertcontainer {\n        margin-top: 0.5%;\n        position: absolute;\n\n        .alertImg {\n            margin-left: 3%;\n        }\n\n        #toast {\n            visibility: hidden;\n            border: 1px solid;\n            border-left: 10px solid;\n            height: auto;\n            width: fit-content !important;\n            background-color: #ffffff;\n            color: #000000;\n            text-align: center;\n            border-radius: 2px;\n            position: fixed;\n            z-index: 1301;\n            left: 0;\n            right: 0;\n            bottom: 36px;\n            font-size: 17px;\n            margin-right: 26px;\n            place-self: end;\n        }\n\n        .toastCloser {\n            margin-top: -6%;\n            background: transparent;\n            border: none;\n        }\n\n        #toast.show {\n            visibility: visible;\n            -webkit-animation: fadein 0.5s, fadeout 0.5s 1s;\n            animation: fadein 0.5s, fadeout 0.5s 1.5s;\n        }\n\n        @-webkit-keyframes fadein {\n            from {\n                left: 30%;\n                opacity: 0;\n            }\n\n            to {\n                left: 0%;\n                opacity: 1;\n            }\n        }\n\n        @keyframes fadein {\n            from {\n                left: 30%;\n                opacity: 0;\n            }\n\n            to {\n                left: 0%;\n                opacity: 1;\n            }\n        }\n\n        @-webkit-keyframes fadeout {\n            from {\n                left: 0%;\n                opacity: 1;\n            }\n\n            to {\n                left: 30%;\n                opacity: 0;\n            }\n        }\n\n        @keyframes fadeout {\n            from {\n                left: 0%;\n                opacity: 1;\n            }\n\n            to {\n                left: 30%;\n                opacity: 0;\n            }\n        }\n\n        .messageheadContainer {\n            display: flex;\n            width: 100%;\n            justify-content: space-between;\n            padding: 0%;\n            padding-top: 1%;\n            padding-left: 5%;\n            padding-bottom: 0%;\n        }\n\n        .toast-check {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            height: 35px;\n            width: 35px;\n            background-color: #40f467;\n            border-radius: 50%;\n            color: #fff;\n            font-size: 20px;\n        }\n\n        .message {\n            display: flex;\n            flex-direction: column;\n            margin: 1px 20px 0px 7px;\n            text-align: left;\n            padding-left: 3%;\n        }\n\n        .message-text {\n            font-size: 20px;\n            font-weight: 600;\n        }\n\n        .text-1 {\n            color: #333;\n            margin-top: 1%;\n        }\n\n        .text-2 {\n            color: #666;\n            font-weight: 400;\n            font-size: 16px;\n            min-width: 202px;\n            height: auto;\n        }\n\n        .toast-close {\n            position: absolute;\n            top: 10px;\n            right: 15px;\n            padding: 5px;\n            cursor: pointer;\n            opacity: 0.7;\n        }\n\n        .toast-close:hover {\n            opacity: 1;\n        }\n    }\n\n    .initialLoader {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: rgba(0, 0, 0, 0.5);\n        /* Semi-transparent background */\n        justify-content: center;\n        align-items: center;\n        z-index: 9999;\n        /* Ensure it's above all other elements */\n        display: flex;\n        flex-direction: column;\n    }\n\n    .fileUploadText {\n        color: white;\n        font-size: 25px;\n        font-weight: 600;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
